<script lang="ts">
	import { format } from 'svelte-i18n';
	import { profile_data } from 'src/stores/account/user';
	import { active_integrations, alexaInstalled } from 'src/stores/integrations/alexa';
	import { Text, Button, Modal, Container } from '@Shelly/shelly-design-system';
	import { save_profile } from '../helpers/profile_helpers';
	import { push } from 'svelte-spa-router';
	import { capFirstChar } from 'src/helpers/utilities';
	import { onMount } from 'svelte';
	import { mobile } from 'src/services/mobile-rework';

	$: showModal =
		$alexaInstalled &&
		typeof $profile_data?.alexaIntegrationPrompt?.seen !== 'undefined' &&
		!$profile_data?.alexaIntegrationPrompt?.seen &&
		!$active_integrations.includes('alexa');

	const updateHomeData = () => {
		save_profile('alexaIntegrationPrompt', {
			seen: true,
		});

		profile_data.set({
			...$profile_data,
			alexaIntegrationPrompt: {
				seen: true,
			},
		});
	};

	const handleCloseModal = () => {
		showModal = false;
		updateHomeData();
	};

	const handleSave = () => {
		push('/settings/app-to-app-alexa');
		handleCloseModal();
	};

	const handleCancel = () => {
		handleCloseModal();
	};

	const closeModal = (e: CustomEvent) => {
		if (showModal) {
			e.preventDefault();
			handleCloseModal();
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

<Modal on:close={handleCancel} {showModal} title="">
	<Container slot="content" padding="0">
		<div class="text-center">
			<img class="mb-m mt-m" src="./images/alexa-logo.svg" alt="second-logo" />
			<Text class="mb-m" styleType="h1"
				>{capFirstChar(
					$format('text_title_alexa_integration_prompt_mobile', {
						default: 'Integrate with Alexa',
					}),
				)}</Text
			>
			<Text class="mb-l"
				>{capFirstChar(
					$format('text_description_alexa_integration_prompt_mobile', {
						default:
							'Control your Shelly devices with your voice. Integrate with Alexa to control your devices with voice commands.',
					}),
				)}
			</Text>
		</div>

		<div class="text-center">
			<Button class="width-md-s width-sm-full mb-m" on:click={handleSave}>
				{capFirstChar(
					$format('button_link_with_alexa', {
						default: 'Link with Alexa',
					}),
				)}
			</Button>
			<Text class="d-inline-flex text-primary cursor-pointer mb-m" on:click={handleCancel}>
				{capFirstChar($format('button_dont_ask', { default: "Don't ask again" }))}
			</Text>
		</div>
	</Container>
</Modal>
